import { render, staticRenderFns } from "./ordersList.vue?vue&type=template&id=2694b4c7&scoped=true&"
import script from "./ordersList.vue?vue&type=script&lang=js&"
export * from "./ordersList.vue?vue&type=script&lang=js&"
import style0 from "./ordersList.vue?vue&type=style&index=0&id=2694b4c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694b4c7",
  null
  
)

export default component.exports